import { enUS } from "./en-US"

export const def = enUS
